module.exports = __webpack_public_path__ + "static/media/student8.92d85691.svg";